import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { Manufacturer } from 'src/typings';
import { CreateManufacturerComponent } from '../create-manufacturer/create-manufacturer.component';
import { ManufacturerService } from '../manufacturer.service';

@Component({
  selector: 'app-manufacturer-selector',
  templateUrl: './manufacturer-selector.component.html',
  styleUrls: ['./manufacturer-selector.component.scss']
})
export class ManufacturerSelectorComponent implements OnInit {
  @Input() control: UntypedFormControl = new UntypedFormControl();

  manufacturers: Manufacturer[] = [];

  filteredOptions: Observable<Manufacturer[]> = new Observable();

  value: any;

  constructor(private manufacturerService: ManufacturerService, private dialog: MatDialog) {
    this.loadManufacturers();
    this.manufacturerService.manufacturerGW.subscribe(() => {
      this.loadManufacturers();
    });
  }

  loadManufacturers() {
    this.manufacturerService.search().subscribe((list) => {
      this.manufacturers = list.data;
    });
  }

  ngOnInit(): void {
    this.filteredOptions = this.control.valueChanges.pipe(
      startWith(''),
      map((value) => {
        return this._filter(value);
      })
    );
  }

  public displayProperty(manufacturer: any) {
    if (manufacturer) {
      return manufacturer.description;
    } else {
      return;
    }
  }

  private _filter(value: string | Manufacturer): Manufacturer[] {
    const lowerValue =
      typeof value === 'string' ? value.toLowerCase() : value?.description.toLowerCase();

    return this.manufacturers.filter((manufacturer) =>
      manufacturer.description.toLowerCase().includes(lowerValue)
    );
  }

  openDialog() {
    const dialogRef = this.dialog.open(CreateManufacturerComponent);
    dialogRef.componentInstance.descriptionControl.setValue(this.control.value);
    dialogRef.componentInstance.dialogRef = dialogRef;
    dialogRef.componentInstance.createEvent.subscribe((newManufacturer) => {
      this.control.setValue(newManufacturer);
    });
  }

  handleSelect(event: MatAutocompleteSelectedEvent) {
    if (typeof event.option.value === 'string') {
      this.openDialog();
    }
  }
}
